import * as React from 'react';
import { connect } from 'react-redux';
import { RequestApiResult, requestAPIActions } from 'loopback-react-request';
import { ConfigurationDefaultModel, ConfigurationModel } from 'franke-trough-dependencies';
import { GlobalPrivateState } from 'src/api';

export interface ConfigurationDefaultsDispatcherProps {
  dispatch: any;
  configuration: RequestApiResult<ConfigurationModel>;
  configurationDefaults: RequestApiResult<ConfigurationDefaultModel>;
  id: string;
}

const dispatchKey = 'configurationDefaults';

class ConfigurationDefaultsDispatcherContainer extends React.Component<ConfigurationDefaultsDispatcherProps, any> {

  componentDidMount() {
    this.dispatchConfigurationDefaults();
  }

  componentDidUpdate(prevProps: ConfigurationDefaultsDispatcherProps) {
    const configuration = this.props.configuration.result;
    const prevConfiguration = prevProps.configuration.result;
    if (!prevConfiguration && configuration && !this.props.configurationDefaults.result) {
      this.dispatchConfigurationDefaults(true);
    }

    if (prevConfiguration && ((configuration && configuration.updated_at) !== (prevConfiguration && prevConfiguration.updated_at))) {
      this.dispatchConfigurationDefaults(true);
    }
  }

  public render() {
    return null;
  }

  private dispatchConfigurationDefaults(update: boolean = false) {
    const { configuration } = this.props;
    const configurationId = configuration.result && configuration.result.id;
    // this.props.dispatch(requestAPIActions.load(
    //   dispatchKey, {
    //     url: `/Configurations/defaults?id=${configurationId && configurationId.length > 0 ? configurationId : this.props.id}`,
    //     options: {
    //       isPager: update,
    //     },
    //   },
    //   true
    // ));
  }
}


export const ConfigurationDefaultsDispatcher = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  configurationDefaults: state.configurationDefaults,
}))(ConfigurationDefaultsDispatcherContainer);
